export function scrollToTop() {
  if (typeof window === "undefined") {
    return;
  }

  window.scrollTo({ top: 0, behavior: "smooth" });
}

export function scrollToElementById(id: string) {
  if (typeof document === "undefined") {
    return;
  }

  const target = document.getElementById(id);

  if (target) {
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

export function openHomeSection(
  navigateHome: (() => void) | undefined,
  sectionId: string,
  delay = 120,
) {
  navigateHome?.();

  if (typeof window === "undefined") {
    return;
  }

  window.setTimeout(() => {
    scrollToElementById(sectionId);
  }, delay);
}
